// extracted by mini-css-extract-plugin
export default {"dataFieldContainer":"styles_dataFieldContainer__DZeHo","dataSection":"styles_dataSection__RC+O9"};